import { useContext } from "react";
import { BudgetTableContext } from "./types";

export const useBudgetTableContext = () => {
  return useContext(BudgetTableContext);
};